import {Injectable} from "@angular/core";
import {APIProxy, HttpObservable} from "../../../common/http/services";
import {
	IMDTMeeting,
	IMDTMeetingsAvailableIn,
	IMDTMeetingOrderingOrg,
	IMDTMeetingsFavoritesDataResponse,
	IMDTMeetingsCalendarContentResponse,
	IMDTMeetingCancellation,
	IMDTMeetingsCancellationRequest,
	IMDTMeetingsAddRequest,
	IMDTMeetingsMoveRequest,
	IMDTMeetingsRemoveRequest,
	IMDTMeetingSequenceIDRequest
} from "../interfaces/mdt.meetings.interface";
import {INode} from "../interfaces/mdt.meetings.interface";
import {map} from "rxjs/operators";

@Injectable({ providedIn: 'root' })
  export class MDTMeetingsProxy {
	public dateParser = new RegExp(".*");

	constructor(private http:APIProxy){
	}

	public getMDTMeetingsFavoritesData(): HttpObservable<IMDTMeetingsFavoritesDataResponse> {
		return this.http.get("MDTMeetings","GetMDTMeetingsFavoritesData");
	}

	public getMDTMeetingsCurrentUserOrganizationsRoot(): HttpObservable<INode> {
		return this.http.get("MDTMeetings","GetMDTMeetingsCurrentUserOrganizationsRoot");
	}

	public getFavoritesMDTMeetingsOrgStructureTree(): HttpObservable<INode> {
		return this.http.get("MDTMeetings", "GetFavoritesMDTMeetingsOrgStructureTree");
	}

	public addMDTMeetingFavorite(favoriteMeeting: IMDTMeeting): HttpObservable<void> {
		return this.http.post("MDTMeetings", "AddMDTMeetingFavorite", favoriteMeeting);
	}

	public removeMDTMeetingFavorite(favoriteMeeting: IMDTMeeting): HttpObservable<void> {
		return this.http.post("MDTMeetings", "RemoveMDTMeetingFavorite", favoriteMeeting);
	}

	public setDefaultFavoriteMeeting(defaultFavoriteMeeting: number): HttpObservable<void> {
		return this.http.post("MDTMeetings", "SetDefaultFavoriteMeeting", defaultFavoriteMeeting);
	}

	public getMDTMeetingsAvailableInList(siteWorklistKey: number): HttpObservable<IMDTMeetingsAvailableIn[]>{
		return this.http.get("MDTMeetings", "GetMDTMeetingsAvailableInList",[{pName: "siteWorklistKey", pVal: siteWorklistKey}]);
	}

	public getMDTMeetingOrganizationStructure(organizationStructureKey: number) : HttpObservable<string>{
		return this.http.get("MDTMeetings", "GetMDTMeetingOrganizationStructure",[{pName: "organizationStructureKey", pVal: organizationStructureKey}]);
	}

	public getMDTMeetingOrderingOrgs(conferenceKey: number): HttpObservable<IMDTMeetingOrderingOrg[]>{
		return this.http.get("MDTMeetings", "GetMDTMeetingOrderingOrgs",[{pName: "conferenceKey", pVal: conferenceKey}]);
	}

	public getMDTMeetingScheduled(conferenceKey: number){
		return this.http.get("MDTMeetings","GetMDTMeetingScheduled", [{pName: "conferenceKey", pVal: conferenceKey}]);
	}

	public getMDTMeetingCalendarContent(conferenceKey: number, date:Date): HttpObservable<IMDTMeetingsCalendarContentResponse>{
		return this.http.get("MDTMeetings", "GetMDTMeetingCalendarContent",
			[{pName: "conferenceKey", pVal: conferenceKey},
			{pName: "date", pVal: date}])
			.pipe(map(raw => this.http.parseDates(raw, new RegExp(".*"))));
	}

	public getMDTMeetingCancellationByYear(conferenceKey: number, selectedDate:string): HttpObservable<IMDTMeetingCancellation[]>{
		return this.http.get("MDTMeetings", "GetMDTMeetingCancellationByYear",[{pName: "conferenceKey", pVal: conferenceKey},
			{pName: "date", pVal:selectedDate}])
			.pipe(map(raw => this.http.parseDates(raw, new RegExp(".*"))));
	}

	public getMeetingWorklistRowsNumberByDate(conferenceKey: number, date:string): HttpObservable<number>{
		return this.http.get("MDTMeetings", "GetMeetingWorklistRowsNumberByDate",[{pName: "conferenceKey", pVal: conferenceKey},
			{pName: "date", pVal:date}]);
	}

	public getMDTMeetingFromConferenceKey(conferenceKey: number) : HttpObservable<IMDTMeeting>{
		return this.http.get("MDTMeetings", "GetMDTMeetingFromConferenceKey", [{pName: "conferenceKey", pVal: conferenceKey}]);
	}

	public cancelOccurrence(cancellationRequest: IMDTMeetingsCancellationRequest): HttpObservable<void> {
		return this.http.post("MDTMeetings", "CancelOccurrence", cancellationRequest);
	}

	public addToMDTMeeting(addMDTMeetingRequest: IMDTMeetingsAddRequest): HttpObservable<void> {
		return this.http.post("MDTMeetings", "AddToMDTMeeting", addMDTMeetingRequest);
	}

	public moveToMDTMeeting(moveMDTMeetingRequest: IMDTMeetingsMoveRequest): HttpObservable<void> {
		return this.http.post("MDTMeetings", "MoveToMDTMeeting", moveMDTMeetingRequest);
	}

	public removeFromMDTMeeting(removeMDTMeetingRequest: IMDTMeetingsRemoveRequest[]): HttpObservable<void> {
		return this.http.post("MDTMeetings", "RemoveFromMDTMeeting", removeMDTMeetingRequest);
	}

	public setStudySequenceIDInMDTMeetingWorklist(request: IMDTMeetingSequenceIDRequest, changeSingleWorklistRow: boolean): HttpObservable<void> {
		return this.http.post("MDTMeetings", "setStudySequenceIDInMDTMeetingWorklist", request,
			[{pName: "changeSingleWorklistRow", pVal: changeSingleWorklistRow}]);
	}
}
